import { SearchType } from 'types/api/audience/enums';

export const filterFilterValues = () => {
  return Object.values(SearchType).filter(
    (value) =>
      value !== SearchType.None &&
      value !== SearchType.Basic &&
      value !== SearchType.DataSource &&
      value !== SearchType.Conditions &&
      value !== SearchType.Miscellaneous &&
      value !== SearchType.Tags &&
      value !== SearchType.Sequences &&
      value !== SearchType.IncludeOutOfStateDonor &&
      value !== SearchType.Attributes &&
      value !== SearchType.Gender
  );
};
